import { useEffect, useState } from "react";
import "./style.css";

const CheckBoxCard = ({
  title,
  handleCheckAnswerClick,
  children,
  defaultValue = false,
}) => {
  const [isChecked, setIsChecked] = useState(defaultValue);
  
  useEffect(() => {
    setIsChecked(defaultValue);
  }, [defaultValue]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    handleCheckAnswerClick(!isChecked);
  };

  return (
    <div className={`card ${isChecked ? "card--checked" : ""}`}>
      <div className="card__checkbox">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
      </div>

      <div className="card__content">
        <h3 className="card__title">{title}</h3>
        <p className="card__description">{children}</p>
      </div>
    </div>
  );
};

export default CheckBoxCard;
